<div class="aacl-toast">
    <span *ngFor="let item of notifications$|async">
        <tam-notification [options]="item" [isAddInMode]="isAddInMode"></tam-notification>
    </span>
</div>